import { Input } from 'cdk-radial';
import styled from 'styled-components';

export const StyledInterCompanyDatePicker = styled.div`
  .DayPicker {
    left: calc(100% - 610px) !important;
    margin-left: 300px !important;
  }
  width: 240px;
  height: 48px;
`;

export const StyledInterCompanyPostingDesc = styled(Input)`
  width: 240px;
  height: 40px;
  gap: 16px;
`;

export const StyledInterCompany = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 18px;
  margin-left: 16px;
  gap: 16px;
`;

export const StyledColumn = styled.div`
  display: flex;
  gap: 16px;
`;
